// extracted by mini-css-extract-plugin
export var playbooks = "style-module--playbooks--fdc3c";
export var playbooks__featured = "style-module--playbooks__featured--9b78e";
export var playbooks__image = "style-module--playbooks__image--b283f";
export var playbooks__link = "style-module--playbooks__link--e0607";
export var playbooks__text = "style-module--playbooks__text--93135";